import type { MaturityItemId } from '@cobliteam/hooks/src/useBasicValueMaturity/basicValueMaturityModel';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface BasicValueGuideState {
  /** Item the guided modal was manually opened at (from the Basic Value page), or null. */
  openItemId: MaturityItemId | null;
  /** Open the guided modal focused on a specific item. */
  openAt: (itemId: MaturityItemId) => void;
  /** Close the manually-opened guide. */
  close: () => void;
}

/**
 * App-wide control to open the Basic Value guided modal imperatively at a given step — used by the
 * "Configurações iniciais" page so "Configurar" opens the same modal instead of navigating away.
 * The modal also shows automatically (auto-popup) via useBasicValueOnboardingSource; this store only
 * drives the manual entry point.
 */
const useBasicValueGuideStore = create<BasicValueGuideState, [['zustand/devtools', never]]>(
  devtools(
    (set) => ({
      openItemId: null,
      openAt: (itemId) => set({ openItemId: itemId }, false, 'basicValueGuide/openAt'),
      close: () => set({ openItemId: null }, false, 'basicValueGuide/close'),
    }),
    { name: 'useBasicValueGuideStore' }
  )
);

export default useBasicValueGuideStore;
